<div>
	<button mat-raised-button color="primary">Choose File</button>
	<span>{{file ? file.name : ' or drag and drop file here' }}</span>
	<input class="file-input" type="file" [accept]="accept?.join(',')">
	<div *ngIf="displayError">{{errorMessage}}</div>
</div>